/** biome-ignore-all lint/a11y/noSvgWithoutTitle: avoid triggering biome warning */
import React from 'react';
import styles from './style.cssmodule.css';

export default function Spinner() {
  return (
    <svg
      className={styles.container}
      viewBox="0 0 40 40"
    >
      <circle
        className={styles.track}
        cx="20"
        cy="20"
        r="17.5"
        pathLength="100"
        strokeWidth="5px"
        fill="none"
      />
      <circle
        className={styles.car}
        cx="20"
        cy="20"
        r="17.5"
        pathLength="100"
        strokeWidth="5px"
        fill="none"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./components/loaders/Spinner/Spinner.js